<template>
  <div class="products">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Products',
};
</script>
